export default __webpack_public_path__ + "media/images/logo-b250-f147a52e2cc9f671b53f61b97ae5f83e.png";